import InputAdornment from "@mui/material/InputAdornment";
import { FairPaySurveyResponseContext } from "contexts/FairPaySurveyResponse";
import { useContext } from "react";

import {
  ErrorField,
  FairPayAnnualIncome,
  FairPayExperienceLength,
  FairPayMonthlyIncome,
} from "features/FairPaySurvey/schemas";

import FairPaySelect from "../components/FairPaySelect";
import FairPayTextField from "../components/FairPayTextField";

interface Props {
  error: ErrorField | null;
  setError: React.Dispatch<React.SetStateAction<ErrorField | null>>;
}

const FairPayDealsEarning = ({ error, setError }: Props) => {
  const { fairPaySurveyResponse } = useContext(FairPaySurveyResponseContext);

  return (
    <>
      <FairPayTextField
        placeholder="Biggest brand you've worked with"
        name={"highestEarningBrand"}
        value={fairPaySurveyResponse?.highestEarningBrand}
      />
      <FairPayTextField
        placeholder="Income from your biggest brand"
        name={"highestEarningBrandIncome"}
        value={fairPaySurveyResponse?.highestEarningBrandIncome}
        type="number"
        startAdornment={<InputAdornment position="start">$</InputAdornment>}
        endAdornment={<InputAdornment position="end">USD</InputAdornment>}
        onBlur={(name, value) => {
          const range = [0, 1000000];
          if (Number(value) < range[0] || Number(value) > range[1]) {
            setError({
              name,
              message:
                "Invalid brand income value. Must be between $0 and $1,000,000.",
            });
          } else {
            setError(null);
          }
        }}
        error={error?.message}
      />
      <FairPaySelect
        label={"How long have you been earning income as a creator?"}
        name="experienceLength"
        options={Object.values(FairPayExperienceLength)}
        selectedOption={fairPaySurveyResponse?.experienceLength}
        required={true}
      />
      <FairPaySelect
        label={"Monthly income as a creator (on average, in USD)"}
        name="monthlyIncome"
        options={Object.values(FairPayMonthlyIncome)}
        selectedOption={fairPaySurveyResponse?.monthlyIncome}
        required={true}
        isCurrency={true}
      />
      <FairPaySelect
        label={"Annual income as a creator (in USD)"}
        name="annualIncome"
        options={Object.values(FairPayAnnualIncome)}
        selectedOption={fairPaySurveyResponse?.annualIncome}
        required={true}
        isCurrency={true}
      />
    </>
  );
};

export default FairPayDealsEarning;
